import { useCallback, useEffect, useState } from "react";
import { isWaiting, listSunoVoices } from "@/lib/sunoVoicesApi";

const POLL_MS = 5000;

/** Your Suno voices (newest first); keeps checking while one is still being made. */
export default function useSunoVoices() {
  const [voices, setVoices] = useState(null);
  const reload = useCallback(() => listSunoVoices().then(setVoices).catch(() => setVoices((v) => v || [])), []);
  useEffect(() => { reload(); }, [reload]);
  const waiting = (voices || []).some(isWaiting);
  useEffect(() => {
    if (!waiting) return undefined;
    const t = setInterval(reload, POLL_MS);
    return () => clearInterval(t);
  }, [waiting, reload]);
  return { voices, reload };
}
